module.exports = __webpack_public_path__ + "static/media/Profile_5.8921abaf.svg";